// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2_UhR","productName":"Table_productName__t2Pyh"};